import { useMutation } from '@tanstack/react-query'
import { client } from './client';

export const useMediaUpload = () => {
  const token = localStorage.getItem('accessToken')

  return useMutation({
    mutationFn: async ({ file, folderName }) => {
      const formData = new FormData()
      formData.append('file', file)

      const response = await client(`media-upload/mediaFiles/${folderName}`, {
        method: 'POST',
        data: formData,
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
        },
      })

      return response
    },
  })
}